
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { eosApi } from './api'

export default {
components: {
Group,
Cell
},
data () {
return {
msg: 'Hello World!',
tx_id: '',
}
},
methods: {
getTransaction () {
var tx_id = this.tx_id.trim();
if (tx_id.length != 64) {
alert('格式错误，交易 ID 必须是 64 位的字符串');
return
}

eosApi.getTransaction(this.tx_id).then(function (data) {
alert(data);
});
}
},
}



// WEBPACK FOOTER //
// ./src/result.vue